import React__default from 'react';

const Spinner = () => {
    return (React__default.createElement("svg", { width: "38", height: "38", viewBox: "0 0 38 38", xmlns: "http://www.w3.org/2000/svg", stroke: "#000", className: 'iso__spinner' },
        React__default.createElement("g", { fill: "none", fillRule: "evenodd" },
            React__default.createElement("g", { transform: "translate(1 1)", strokeWidth: "2" },
                React__default.createElement("circle", { strokeOpacity: ".5", cx: "18", cy: "18", r: "18" }),
                React__default.createElement("path", { d: "M36 18c0-9.94-8.06-18-18-18" },
                    React__default.createElement("animateTransform", { attributeName: "transform", type: "rotate", from: "0 18 18", to: "360 18 18", dur: "1s", repeatCount: "indefinite" }))))));
};

export { Spinner as default };
//# sourceMappingURL=Spinner.js.map
